import request from '@/services/interceptor.js'

// Anagrafica domande (solo admin)
export const get_anagrafica_auditFSC = () => {
    return request({
        url: 'AuditFSC/anagrafica',
        method: 'get',
        noLoadingBar: true
    })
}

export const salva_capitolo_auditFSC = (capitolo) => {
    return request({
        url: 'AuditFSC/anagrafica/capitolo',
        method: 'post',
        data: capitolo,
        loadingBar: true
    })
}

export const elimina_capitolo_auditFSC = (id) => {
    return request({
        url: 'AuditFSC/anagrafica/capitolo/elimina?id=' + encodeURIComponent(id),
        method: 'post',
        loadingBar: true
    })
}

export const salva_requisito_auditFSC = (requisito) => {
    return request({
        url: 'AuditFSC/anagrafica/requisito',
        method: 'post',
        data: requisito,
        loadingBar: true
    })
}

export const elimina_requisito_auditFSC = (id) => {
    return request({
        url: 'AuditFSC/anagrafica/requisito/elimina?id=' + encodeURIComponent(id),
        method: 'post',
        loadingBar: true
    })
}

// Elenco clienti/edizioni + compilazione (admin + auditor)
export const get_elencoClienti_auditFSC = () => {
    return request({
        url: 'AuditFSC/elenco-clienti',
        method: 'get',
        noLoadingBar: true
    })
}

export const get_audit_auditFSC = (companyCode, numero) => {
    return request({
        url: 'AuditFSC/audit?companyCode=' + encodeURIComponent(companyCode) + '&numero=' + encodeURIComponent(numero),
        method: 'get',
        noLoadingBar: true
    })
}

export const salva_audit_auditFSC = (dati, silenzioso) => {
    return request({
        url: 'AuditFSC/audit',
        method: 'post',
        data: dati,
        loadingBar: !silenzioso
    })
}

export const conferma_audit_auditFSC = (companyCode, numero) => {
    return request({
        url: 'AuditFSC/audit/conferma?companyCode=' + encodeURIComponent(companyCode) + '&numero=' + encodeURIComponent(numero),
        method: 'post',
        loadingBar: true
    })
}

export const salva_chiusuraNC_auditFSC = (dati) => {
    return request({
        url: 'AuditFSC/nc/chiusura',
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

export const get_commesseSelezionabili_auditFSC = (companyCode) => {
    return request({
        url: 'AuditFSC/commesse?companyCode=' + encodeURIComponent(companyCode),
        method: 'get',
        noLoadingBar: true
    })
}

export const get_nonConformita_auditFSC = (companyCode) => {
    return request({
        url: 'AuditFSC/nc?companyCode=' + encodeURIComponent(companyCode),
        method: 'get',
        noLoadingBar: true
    })
}

export const download_pdf_auditFSC = (companyCode, numero) => {
    return request({
        url: 'AuditFSC/audit/pdf?companyCode=' + encodeURIComponent(companyCode) + '&numero=' + encodeURIComponent(numero),
        method: 'get',
        responseType: 'blob',
        loadingBar: true
    })
}
